import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { ChevronsUpDown, Check, Search } from "lucide-react";

// Searchable service picker: type any part of the name/category to filter instantly.
// Displays "Service Name — Duration min". Drop-in replacement for the plain service dropdown.
export const ServiceSelect = ({ services = [], value, onChange, placeholder = "Service", testid = "service-select" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = services.find((s) => s.id === value);
  const money = (n) => `₹${(Number(n) || 0).toLocaleString("en-IN")}`;
  const t = q.trim().toLowerCase();
  const num = Number(t.replace(/[₹,\s]/g, ""));
  const isNum = t !== "" && /\d/.test(t) && !/[a-z]/.test(t) && !isNaN(num);
  const filtered = !t
    ? services
    : services.filter((s) => {
        if (isNum) {
          const p = Number(s.price) || 0;
          return p === num || String(p).includes(String(num)) || Math.abs(p - num) <= Math.max(100, num * 0.1);
        }
        return (s.name || "").toLowerCase().includes(t) || (s.category || "").toLowerCase().includes(t);
      });

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-secondary px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
          <span className={`truncate ${selected ? "" : "text-muted-foreground"}`}>
            {selected ? `${selected.name} — ${selected.duration} min — ${money(selected.price)}` : placeholder}
          </span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px] bg-card border-border">
        <div className="flex items-center gap-2 border-b border-border px-3 py-2">
          <Search className="h-4 w-4 text-muted-foreground shrink-0" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, category or price..."
            data-testid={`${testid}-search`}
            className="w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground" />
        </div>
        <div className="max-h-64 overflow-y-auto py-1" data-testid={`${testid}-list`}>
          {filtered.length === 0 && (
            <p className="px-3 py-6 text-center text-sm text-muted-foreground" data-testid={`${testid}-empty`}>No services found</p>
          )}
          {filtered.map((s) => (
            <button key={s.id} type="button" data-testid={`${testid}-opt-${s.id}`}
              onClick={() => { onChange(s.id); setOpen(false); setQ(""); }}
              className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm hover:bg-secondary transition-colors">
              <span className="truncate">{s.name} <span className="text-muted-foreground">| {s.duration} min | {money(s.price)}</span></span>
              {s.id === value && <Check className="h-4 w-4 text-primary shrink-0 ml-2" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
